/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Why_Quote_EndInputs */

const en_dr_why_quote_end = /** @type {(inputs: Dr_Why_Quote_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const id_dr_why_quote_end = /** @type {(inputs: Dr_Why_Quote_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {Dr_Why_Quote_EndInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_why_quote_end = /** @type {((inputs?: Dr_Why_Quote_EndInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Why_Quote_EndInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_why_quote_end(inputs)
	return en_dr_why_quote_end(inputs)
});